import { generateUtilityClasses } from '@mui/material';

export const comboBoxClasses = generateUtilityClasses('ComboBox', [
  'textInput',
  'popper',
  'paper',
  'menuList',
]);
